import React from 'react';
import { Alert, Box } from '@mui/material';
import { formatAnonymizedDate } from './AnonymizedBadge';

/**
 * Aviso da ficha lápide: o paciente foi excluído (LGPD) e o prontuário não
 * existe mais. Substitui o conteúdo das abas Dados pessoais, Saúde e Documentos;
 * Agendamentos, Financeiro e Notas fiscais continuam funcionando.
 * Especificação: docs/features/lgpd-eliminacao/README.md
 */
function TombstoneNotice({ deletedAt }) {
    return (
        <Box sx={{ display: 'flex', justifyContent: 'center', padding: '32px 0' }}>
            <Alert severity="info" sx={{ maxWidth: '640px', width: '100%' }}>
                {`Os dados deste paciente foram excluídos em ${formatAnonymizedDate(deletedAt)}. `}
                Restaram apenas agendamentos passados, financeiro e notas fiscais, sem identificação.
            </Alert>
        </Box>
    );
}

export default TombstoneNotice;
